import { request } from '@/utils/request';
import ENDPOINT from "@/config/endpoint";

function getIamAccount(params) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/accounts`,
    method: 'get',
    params: params
  });
}

function updateAccount(id, data) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/accounts/${id}`,
    method: 'patch',
    data,
  });
}

function inviteAccount(data) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/invitations`,
    method: 'post',
    data,
  });
}

function blockAccount(id) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/accounts/${id}/block`,
    method: 'post',
  });
}

function unblockAccount(id) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/accounts/${id}/unblock`,
    method: 'post',
  });
}

function deleteIamAccount(id) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/accounts/${id}/delete`,
    method: 'DELETE',
  });
}

function deleteInviteIamAccount(id) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/invitations/${id}`,
    method: 'DELETE',
  });
}

function changeRole(id, data) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/accounts/${id}/roles`,
    method: 'patch',
    data,
  });
}

function getPermission() {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/roles`,
    method: 'get',
  })
}

function createIamSubAccount(data) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/accounts`,
    method: 'post',
    data,
  })
}

function getResource() {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/resources`,
    method: 'get',
  })
}

function getResourcePermission(params) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/resources/permission`,
    method: 'get',
    params,
  })
}

function addIamResource(data) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/resources`,
    method: 'post',
    data,
  })
}

function deleteResource(id) {
  return request({
    url: `${ENDPOINT.IAM_BACKEND}/resources/${id}`,
    method: 'DELETE',
  });
}

export default {
  getIamAccount,
  updateAccount,
  inviteAccount,
  blockAccount,
  unblockAccount,
  deleteIamAccount,
  deleteInviteIamAccount,
  changeRole,
  getPermission,
  createIamSubAccount,
  getResource,
  getResourcePermission,
  addIamResource,
  deleteResource,
}